export const brokerPage = {
  title: 'IHR HELFER BEIM IMMOBILIENVERKAUF',
  subtitle: 'Jetzt Ihren Wunschmakler finden – Seriös. Einfach. Regional.',
  subtitleB: 'Jetzt Ihren Wunschmakler finden – Seriös. <br/>Einfach. Regional.',
  titleMobile: 'WIR FINDEN IHREN MAKLER',
  subtitleMobile: 'Seriös. Einfach. Regional.',
  bannerAdvantage1: 'Kostenlose <br/>Immobilienbewertung',
  bannerAdvantage2: 'Regionale <br/>Anbieter',
  bannerAdvantage3: 'Unverbindliche <br/>Offerten',
  brokerSaveTime: 'Zeit sparen',
  brokerRegional: 'Regionale und seriöse Makler',
  brokerFree: 'Kostenloser Maklervorschlag',
  findBrokerTitle: `Mit Mein-Makler.ch Ihren Wunschmakler finden – so einfach geht's:`,
  findBrokerTitleB: `Mit MaklerVergleichen24.ch Ihren Wunschmakler finden – so einfach geht's:`,
  findBrokerTitle1: '1. Verkaufsprojekt erfassen ',
  findBrokerText1:
    'Sie erfassen die wichtigsten Objektdaten, damit wir den passenden Makler für Sie finden können.',
  findBrokerTitle2: '2. Maklervorschlag erhalten',
  findBrokerText2:
    'In unserer Datenbank suchen wir den passenden, regionalen Makler für Ihre Bedürfnisse. Kostenlos und unverbindlich.',
  findBrokerTitle3:
    '3. <span style="word-break: keep-all;">Gratis vor Ort Beratung und Bewertung</span>',
  findBrokerText3:
    'Der passende Makler kommt zur unverbindlichen Erstbesichtigung vorbei und erstellt gratis eine Erstbewertung Ihres Objektes. Im Anschluss können Sie sich entscheiden, ob Sie dem Makler das Mandat übergeben wollen und das Verkaufsprojekt starten.',
  brokerAdvantageTitle: 'Ihre Vorteile',
  brokerAdvantageTitle1: 'Zeit und Mühe sparen',
  brokerAdvantageText1:
    'In wenigen Schritten erfassen wir Ihr Projekt. Danach machen wir uns auf die Suche nach dem passenden Makler für Ihr Verkaufsobjekt. Sie erhalten von uns unverbindliche Maklervorschläge.',
  brokerAdvantageTitle2: 'Qualitätsanbieter aus der Region',
  brokerAdvantageText2:
    'Unsere Partner sind Schweizer Qualitätsanbieter. Die Anbieter sind geprüft und in den verschiedenen Regionen der Schweiz ansässig.',
  brokerAdvantageTitle3: 'Kostenlos und unverbindlich',
  brokerAdvantageText3:
    'Der Makler kommt zur kostenlosen Erstbesichtigung und bewertet auf Wunsch  Ihr Objekt. Im Anschluss können Sie sich entscheiden, ob Sie dem Makler das Mandat übergeben oder nicht.',
  aboutBrokerTitle: 'Über Mein-Makler.ch',
  aboutBrokerSubtitle1:
    'Wir sind ein Schweizer Unternehmen, welches über HausHeld.ch passende  Qualitätsanbieter für Hauseigentümer in den verschiedenen Regionen der Schweiz vermittelt.',
  aboutBrokerSubtitle2: '"Vertrauen und Servicequalität stehen bei uns an erster Stelle."',
  aboutBrokerSubtitle3:
    'Seit 2016 haben wir mit <b><u><a href="/about-us" target="_blank">unserem Team</a></u></b> viel erreicht: ',
  fittingBrokerTitle: 'Passende Makler',
  fittingBrokerText:
    'Mein-Makler.ch findet für Sie kostenlos und unverbindlich den passenden Makler in Ihrer Region.',
  findNow: 'Jetzt Makler finden',
  testimonial:
    'Die Anfrage konnte ich online einfach erstellen, nach kurzer Zeit meldete sich das HausHeld-Team, um weitere Details aufzunehmen. Anschliessend wurde mir ein passender Makler zugeteilt, der Service von HausHeld ist zu empfehlen und ist sehr professionell und freundlich. Die Arbeit beim Suchprozess wurde mir deutlich erleichtert.',
  testimonialName: 'Vreni S.',
  testimonialYear: '2022',
  aboutBrokerBottom: 'Aktive <br />Partner',
}
